import { render, staticRenderFns } from "./ProjectShowOptionSettingsTab.vue?vue&type=template&id=21fb7728"
import script from "./ProjectShowOptionSettingsTab.vue?vue&type=script&lang=ts"
export * from "./ProjectShowOptionSettingsTab.vue?vue&type=script&lang=ts"
import style0 from "./ProjectShowOptionSettingsTab.vue?vue&type=style&index=0&id=21fb7728&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports